import React, { useEffect, useRef, ReactNode } from 'react';

import { ToastBanner } from './ToastBanner';
import { ToastCard } from './ToastCard';

interface Props<I> {
    content?: ReactNode;
    RenderContent?: ToastRenderContent<I>;
    renderContentInput?: I;
    duration: number;
    remove: RemoveToast;
    kind: ToastKind;
    persist?: boolean;
    position?: ToastPosition;
}

export function Toast<I>({
    content,
    RenderContent,
    renderContentInput,
    duration,
    kind,
    remove,
    persist = false,
    position,
}: Props<I>): JSX.Element {
    const removeRef = useRef<RemoveToast>();

    removeRef.current = remove;

    useEffect(() => {
        if (!persist) {
            const timeoutId = setTimeout(() => {
                if (removeRef.current !== undefined) {
                    removeRef.current();
                }
            }, duration);

            return (): void => {
                clearTimeout(timeoutId);
            };
        }

        return undefined;
    }, []);

    if (kind === 'info-banner' || kind === 'warning-banner') {
        return (
            <ToastBanner
                content={content}
                RenderContent={RenderContent}
                renderContentInput={renderContentInput}
                remove={remove}
                kind={kind}
            />
        );
    }

    return (
        <ToastCard
            content={content}
            kind={kind}
            remove={remove}
            RenderContent={RenderContent}
            renderContentInput={renderContentInput}
            position={position}
        />
    );
}
